// extracted by mini-css-extract-plugin
module.exports = {"root":"TopicCreatePage_root__3T0zv","pageHeader":"TopicCreatePage_pageHeader__2EYY6","inputs":"TopicCreatePage_inputs__1J1tj"};